<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="result-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="box-view">
                        <div class="box-wrapper flex-center-start flex-wrap">
                            <div class="box-item" v-for="(item,index) in basket" :key="index">
                                <div class="goods-detail">
                                    <div class="goods-wrapper">
                                        <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                                    </div>                                 
                                </div>                
                            </div>
                        </div>
                    </div>

                    <div class="notice">                        
                        确认领取以上自选奖励，领取后<b>不可更换</b>！
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()"></div>  
                        <div class="u-btn ok" @click="apply_gacha()"></div>                                                                 
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.result-modal{
    position: relative;
    width: 708px;
    height: 380px;
    background-image: url(~@/assets/images/modal/bg-modal-comfirm.png);     
}

.title{
    width: 396px;
    height: 30px;
    margin: 0 auto 35px;
    background-image: url(~@/assets/images/modal/title-comfirm.png);
}

.box-view{

    .box-wrapper{
        padding: 0 60px 0;
    }

    .box-item{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 84px;
        height: 84px;
        margin: 0 16px 24px;
        background-image: url(~@/assets/images/bg-item_2.png);
    }

}

.item-pic{
    width: 46px;
    height: 46px;
}

.notice{
    text-align: center;
    color: #49392e;
    font-size: 20px;
    padding: 0 60px;

    b{
        font-weight: 400;
        color: #b7392a;
    }
}

.u-ctrl{
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    margin-top: 20px;

    .u-btn{
        margin: 0 15px;
    }
}

.u-btn.ok{
    width: 224px;
    height: 65px;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 224px;
    height: 65px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

</style>

<script>
import { apiGachaApply, } from '@/api/index';
export default {
    data () {
        return {
            visible : false,
            text : '',
            isSSr : false,
            item : {},
            basket : [],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            this.$destroy();
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        apply_gacha (){

            let pack_data =[];

            this.basket.forEach(function(val) {
                pack_data.push({ id : val.id , groupId : val.groupId })
            }, {});              

            apiGachaApply(pack_data).then(
                res => {
                    this.$toast('领取成功！');
                    this.destroyElement();
                    //todo
                    this.$store.commit('$_setFlag', 1);
                },
                rej => {
                    this.$toast(rej.message);
                }
            );            
        },              
    },    
}
</script>